module.exports = __webpack_public_path__ + "img/bondarev.c5055925.png";